"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-location.tsx
var Location = function Location(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M9.99967 3.33335C12.7913 3.33335 14.9997 5.47502 14.9997 8.50002C14.9997 10.45 13.3747 13.0334 9.99967 16.1167C6.62467 13.0334 4.99967 10.45 4.99967 8.50002C4.99967 5.47502 7.20801 3.33335 9.99967 3.33335ZM16.6663 8.50002C16.6663 4.35002 13.4997 1.66669 9.99967 1.66669C6.49967 1.66669 3.33301 4.35002 3.33301 8.50002C3.33301 11.2667 5.55801 14.5417 9.99967 18.3334C14.4413 14.5417 16.6663 11.2667 16.6663 8.50002ZM8.95801 8.33335C8.95801 7.75825 9.42457 7.29169 9.99967 7.29169C10.5748 7.29169 11.0413 7.75825 11.0413 8.33335C11.0413 8.90845 10.5748 9.37502 9.99967 9.37502C9.42457 9.37502 8.95801 8.90845 8.95801 8.33335ZM9.99967 6.04169C8.73422 6.04169 7.70801 7.0679 7.70801 8.33335C7.70801 9.59881 8.73422 10.625 9.99967 10.625C11.2651 10.625 12.2913 9.59881 12.2913 8.33335C12.2913 7.0679 11.2651 6.04169 9.99967 6.04169Z",
    fill: "currentColor"
  }));
};

var _default = Location;
exports.default = _default;